import React from "react";
import "./HomeAbout.scss";
import { Link } from "react-router-dom";

import { ReactComponent as SideBtn } from "../../assets/svg/side-btn.svg";
import { HomeAbout1 } from "../../assets/images";

const HomeAbout = () => {
  return (
    <section className="section home-contact">
      <article className="home-contact__container container">
        <div className="home-contact__content-text">
          <h3 className="home-contact__content-title">Why Radiksez?</h3>

          <p className="home-contact__content-desc">
            At Radiksez, we are passionate about helping businesses achieve
            their full potential through the power of human expertise and AI
            technology. We work with businesses to provide all-round support for
            your business from software development to quality assurance
            testing, from social media management to AI & ML validation - all
            without the hassle of hiring!
            <br />
            <br />
            We are committed to delivering best-in-class work that exceeds your
            expectations. We implement rigorous vetting processes and quality
            control measures to guarantee the highest standards of service.
            <br />
            <br />
            Contact us today for a free consultation and discover how we can
            help you thrive in today's competitive landscape.
          </p>

          <Link to="/about-us" className="home-contact__content-btn">
            <button className="home-contact__btn">
              <span> About Us</span>
            </button>
            <SideBtn />
          </Link>
        </div>

        <figure className="home-contact__content-img">
          <img
            src={HomeAbout1}
            width={1000}
            height={1000}
            alt="the home about section"
          />
        </figure>
      </article>
    </section>
  );
};

export default HomeAbout;
